export default "__VITE_ASSET__DOYEZn0u__"